export type BinoBanConfig = {
  apiKey: string;
  sourceIdentifier: string;
  url: string;
};

declare global {
  interface Window {
    Binoban?: {
      track: (name: string, attrs: Record<string, any>) => void;
      identify: (name: string, attrs: Record<string, any>) => void;
      reset: () => void;
    };
  }
}

export const generateBinobanScript = (args: BinoBanConfig) => {
  const { apiKey, sourceIdentifier, url } = args;
  return `!function(){var e="Binoban",r=window[e]=window[e]||[];if(!r.initialize){if(r.invoked){window.console&&console.error&&console.error("‌Binoban snippet included twice.");return}r.invoked=!0,r.methods=["trackSubmit","trackClick","trackLink","trackForm","pageview","identify","reset","group","track","ready","alias","debug","page","screen","once","off","on","addSourceMiddleware","addIntegrationMiddleware","setAnonymousId","addDestinationMiddleware","register"],r.factory=function(t){return function(){if(window[e].initialized)return window[e][t].apply(window[e],arguments);var a=Array.prototype.slice.call(arguments);if(["track","screen","alias","group","page","identify"].indexOf(t)>-1){var i=document.querySelector("link[rel='canonical']");a.push({__t:"bpc",c:i&&i.getAttribute("href")||void 0,p:location.pathname,u:location.href,s:location.search,t:document.title,r:document.referrer})}return a.unshift(t),r.push(a),r}};for(var t=0;t<r.methods.length;t++){var a=r.methods[t];r[a]=r.factory(a)}r.load=function(t){var a=document.createElement("script");a.type="text/javascript",a.async=!0,a.setAttribute("data-global-analytics-key",e),a.src="${url}";var i=document.getElementsByTagName("script")[0];i.parentNode.insertBefore(a,i),r._loadOptions=t},r._apiKey="${apiKey}",r._sourceIdentifier="${sourceIdentifier}",r.SNIPPET_VERSION="1.0.0",r.load(),r.page()}}();
`;
};

export class Binoban {
  static track(name: string, attrs: Record<string, any>) {
    if (!window?.Binoban) return;
    window.Binoban.track(name, attrs);
  }

  static identify(name: string, attrs: Record<string, any>) {
    if (!window?.Binoban) return;
    window.Binoban.identify(name, attrs);
  }

  static reset() {
    if (!window?.Binoban) return;
    window.Binoban.reset();
  }
}
